/**
 * A function to create a log object for the 'memberWebAppScreenOpen' event (evid: 600)
 *
 * Event description: Member.WebApp.Screen.Open.
 *
 * @param {memberWebAppScreenOpenParams} params - The parameters for this event
 * @property {string} step - StepId, optional
 * @property {string} screenName - <ScreenName.ModalOrDialogScreenNameOptional>
 * @property {string} tabName - optional, published / draft / discussion / etc.
 * @property {GUID} challengeId - challengId, optional
 * @property {string} origin - BM Preview / Editor / Site
 * @property {string} participantId - OP participant id
 * @return {LogObject<memberWebAppScreenOpenParams>} LogObject<memberWebAppScreenOpenParams>
 */
export function memberWebAppScreenOpen(params) {
    return { evid: 600, src: 114, endpoint: 'challenges-member-web', params: params };
}
/**
 * A function to create a log object for the 'memberWebAppButtonClick' event (evid: 601)
 *
 * Event description: Button click event
 * (must cover all buttons, Save/Done/Next/Back/New/Link/Share/etc.)
 * for member app
 *
 * @param {memberWebAppButtonClickParams} params - The parameters for this event
 * @property {string} step - string (optional)
 * @property {string} screenName - <ScreenName.ModalOrDialogScreenNameOptional>
 * @property {boolean} isRequired - (optional, for feedback questions)
 * @property {string} tabName - optional, published / draft / discussion / etc.
 * @property {string} userEntry - where click happened (i.e. sidebar, challenge list)
 * @property {GUID} challengeId - guid (optional)
 * @property {string} origin - BM / Editor / Site
 * @property {string} sectionId - section ID
 * @property {string} buttonName - <the button name (code). lower case.>
 * @return {LogObject<memberWebAppButtonClickParams>} LogObject<memberWebAppButtonClickParams>
 */
export function memberWebAppButtonClick(params) {
    return { evid: 601, src: 114, endpoint: 'challenges-member-web', params: params };
}
/**
 * A function to create a log object for the 'memberWebAppOnBeforeAction' event (evid: 603)
 *
 * Event description: Before Action, client event
 * for member app
 *
 * @param {memberWebAppOnBeforeActionParams} params - The parameters for this event
 * @property {string} step - string  (optional)
 * @property {string} screenName - <ScreenName.ModalOrDialogScreenNameOptional>
 * @property {GUID} actionId - <unique value per action, mandatory>
 * @property {string} tabName - tab name - optional
 * @property {GUID} challengeId - guid (current challengeId)
 * @property {string} actionType - challenge_join / payment / join_with_payment / join_request_create / join_request_cancel / step_comment_save / feedback_send / feedback_save / notification_settings_set / step_complete / challenge_complete / challenge_left
 * @property {string} origin - BM / Editor
 * @return {LogObject<memberWebAppOnBeforeActionParams>} LogObject<memberWebAppOnBeforeActionParams>
 */
export function memberWebAppOnBeforeAction(params) {
    return { evid: 603, src: 114, endpoint: 'challenges-member-web', params: params };
}
/**
 * A function to create a log object for the 'memberWebAppQuizCheckSnapshot' event (evid: 604)
 *
 * Event description: Member.WebApp.Quiz.Check.Snapshot.
 *
 * @param {memberWebAppQuizCheckSnapshotParams} params - The parameters for this event
 * @property {string} step - StepId
 * @property {string} screenName - <ScreenName.ModalOrDialogScreenNameOptional>
 * @property {GUID} challengeId - challengId, optional
 * @property {string} origin - Quiz question
 * @property {string} questionsJson - JSON with list of questions and answers + right answer indicator
 * @return {LogObject<memberWebAppQuizCheckSnapshotParams>} LogObject<memberWebAppQuizCheckSnapshotParams>
 */
export function memberWebAppQuizCheckSnapshot(params) {
    return { evid: 604, src: 114, endpoint: 'challenges-member-web', params: params };
}
/**
 * A function to create a log object for the 'memberWebOnAfterAction' event (evid: 610)
 *
 * Event description: after action on client side
 *
 * @param {memberWebOnAfterActionParams} params - The parameters for this event
 * @property {string} screenName - <ScreenName>
 * @property {GUID} actionId - action ID
 * @property {string} actionType - action_type, must be the same as on onBeforeAction, onAction
 * @property {DateTime} startDate_ - selected Challenges Start Date (for Flexible challenges)
 * @return {LogObject<memberWebOnAfterActionParams>} LogObject<memberWebOnAfterActionParams>
 */
export function memberWebOnAfterAction(params) {
    return { evid: 610, src: 114, endpoint: 'challenges-member-web', params: params };
}
/**
 * A function to create a log object for the 'memberWebWidgetShown' event (evid: 620)
 *
 * Event description: When widget has shown on a page (WEB)
 *
 * @param {memberWebWidgetShownParams} params - The parameters for this event
 * @property {string} step - StepId, optional
 * @property {number} itemsCount - items count on a page in a widget
 * @property {string} screenName - WelcomeScreen / ChallengesList/ ChallengeDetails / etc.
 * @property {number} timeSpent - milliseconds
 * @property {GUID} challengeId - challengId, optional
 * @property {string} origin - Site
 * @return {LogObject<memberWebWidgetShownParams>} LogObject<memberWebWidgetShownParams>
 */
export function memberWebWidgetShown(params) {
    return { evid: 620, src: 114, endpoint: 'challenges-member-web', params: params };
}
//# sourceMappingURL=index.js.map